<template>
    <div>
        <v-icon x-small color="yellow">mdi-circle</v-icon>
        <v-icon x-small color="yellow">mdi-circle</v-icon>
        <v-icon x-small color="yellow">mdi-circle-outline</v-icon>
    </div>
</template>

<script>
export default {
name: "IconQuantityMedium"
}
</script>

<style scoped>

</style>
